const FieldName = {
	monthly_premium: "monthly_premium",
	weekly_premium: "weekly_premium",
	monthly_maximum_premium: "monthly_maximum_premium",
	weekly_maximum_premium: "weekly_maximum_premium",
	monthly_minimum_premium: "monthly_minimum_premium",
	weekly_minimum_premium: "weekly_minimum_premium",
	plan_code: "plan_code",
	monthly: "monthly",
	weekly: "weekly",
	plan_name: "plan_name",
	plan_code_lower: "plan_code", // renamed to avoid duplicate key
	carrier_name: "carrier_name",
	plan_year: "plan_year",
	status: "status",
	employee_class: "employee_class",
	start_date: "start_date",
	end_date: "end_date",
	planOrder: "plan_order"
};

const ValidationMessages = {
	plan_name_required: "Plan Name is required",
	plan_code_required: "Plan Code is required",
	carrier_name_required: "Carrier Name is required",
	plan_year_required: "Plan Year is required",
	status_required: "Status is required",
	employee_class_required: "Employee Class is required",
	start_date_required: "Start Date is required",
	end_date_required: "End Date is required",
	end_date_invalid: "End Date cannot be less than start date",
	invalid: "invalid",
	valid: "valid"
};

const ValidationStatus = {
	invalid: "invalid",
	valid: "valid"
} as const;

export const FIELD_NAMES = FieldName;

export const VALIDATION_MESSAGES = ValidationMessages;

export const VALIDATION_STATUS = ValidationStatus;
